import React, { useState } from 'react';
import recallService from '../../../../services/recall.service';
import { showError } from '../../../../utils/ecxSwal';
import { getInitialReportFileName } from './recallsQuery';

function RecallInitialReportButton({
    clinicId,
    recallId,
    request,
    disabled = false,
    variant = 'light-primary',
    showLabel = true,
    label = 'Initial report',
    className = '',
}) {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        if (!clinicId || !recallId || downloading) {
            return;
        }

        setDownloading(true);

        try {
            const response = await recallService.downloadInitialRecallReport(clinicId, recallId);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = getInitialReportFileName(request, recallId);
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Failed to download initial recall report', error);
            showError({
                title: 'Download failed',
                text: error?.response?.data?.message || 'Initial report is not available yet.',
            });
        } finally {
            setDownloading(false);
        }
    };

    return (
        <button
            type="button"
            className={`btn btn-${variant} btn-sm rounded-pill recall-initial-report-btn ${className}`.trim()}
            onClick={handleDownload}
            disabled={disabled || downloading}
            title="Download initial processing report"
        >
            {downloading ? (
                <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    <span>Downloading...</span>
                </>
            ) : (
                <>
                    <i className="bi bi-file-earmark-pdf" aria-hidden="true"></i>
                    {showLabel ? <span>{label}</span> : <span className="visually-hidden">{label}</span>}
                </>
            )}
        </button>
    );
}

export default RecallInitialReportButton;
